// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__WjUVu","positionLeft":"style_positionLeft__r9-Nv","positionRight":"style_positionRight__uF+s4"};